import Vue from "vue";
import VueRouter from "vue-router";
import AuthWrapper from "../auth/authWrapper";
import { role } from "../auth/role";

import Companies from '../components/companies/container'
import FullLicense from '../components/companies/full-license'
import TrialLicense from '../components/companies/trial-license'

import ArchivedCompanies from '../components/companies-archived/container'
import ArchivedFullLicense from '../components/companies-archived/full-license'
import ArchivedTrialLicense from '../components/companies-archived/trial-license'

// import BlockedCompanies from '../components/companies-blocked/container'
// import BlockedFullLicense from '../components/companies-blocked/full-license'
// import BlockedTrialLicense from '../components/companies-blocked/trial-license'

import Dashboard from '../components/dashboard/container'
import Settings from '../components/settings/container'
import Home from '../components/home/container'
import Landing from '../components/landing/container'

Vue.use(VueRouter)

const routes = [
    {
        path: "/",
        component: Landing
    },
    {
        path: '/app',
        component: Home,
        meta: { authorize: [role.Admin] },
        children: [
            {
                path: 'companies',
                name: 'companies',
                component: Companies,
                meta: { authorize: [role.Admin] },
                children: [
                    {
                        path: 'trial',
                        name: 'trial-license',
                        component: TrialLicense,
                        meta: { authorize: [role.Admin] }
                    },
                    {
                        path: 'full',
                        name: 'full-license',
                        component: FullLicense,
                        meta: { authorize: [role.Admin] }
                    }
                ]
            },
            {
                path: 'archived-companies',
                name: 'archived-companies',
                component: ArchivedCompanies,
                meta: { authorize: [role.Admin] },
                children: [
                    {
                        path: 'trial',
                        name: 'trial-license',
                        component: ArchivedTrialLicense,
                        meta: { authorize: [role.Admin] }
                    },
                    {
                        path: 'full',
                        name: 'full-license',
                        component: ArchivedFullLicense,
                        meta: { authorize: [role.Admin] }
                    }
                ]
            },
            // {
            //     path: 'blocked-companies',
            //     name: 'blocked-companies',
            //     component: BlockedCompanies,
            //     meta: { authorize: [role.Admin] },
            //     children: [
            //         {
            //             path: 'trial',
            //             name: 'trial-license',
            //             component: BlockedTrialLicense,
            //             meta: { authorize: [role.Admin] }
            //         },
            //         {
            //             path: 'full',
            //             name: 'full-license',
            //             component: BlockedFullLicense,
            //             meta: { authorize: [role.Admin] }
            //         }
            //     ]
            // },
            {
                path: 'dashboard',
                name: 'dashboard',
                component: Dashboard,
                meta: { authorize: [role.Admin] }
            },
            {
                path: 'settings',
                name: 'settings',
                component: Settings,
                meta: { authorize: [role.Admin] }
            }
        ]
    }
];

const router = new VueRouter({
    mode: "hash",
    base: process.env.BASE_URL,
    routes
  });

router.beforeEach((to, from, next) => {
    if (to && to.path && to.path != "/") {
        AuthWrapper.service.getUser().then((response) => {
            let currentUser = response;
            console.log(currentUser);
            //console.log('Authorize', authorize);
    
            if (!currentUser || !currentUser.profile || !currentUser.profile.role) {
                AuthWrapper.service.login();
            }
            else if (currentUser.profile.role.includes(role.Admin)) {
                return next();
            }
            else {
                AuthWrapper.service.logout();
                //return next({ path: "/" });
            }
        });
    }
    else { next(); }
  });

export default router;